<div>
  <div class="intro row m-0 mb-3">
    <div class="col-md-12 col-xl-5 row m-0 container-description">
      <!-- <div class="avatar col-md-4 col-xl-3">
        <div class="img-avatar">
          <div *ngIf="loading" class="d-flex align-items-center justify-content-center w-100 h-100">
            <div class="loader"></div>
          </div>
          <img [hidden]="loading" class="w-100 h-100" alt="" src="{{welcome?.welcomeMessage?.avatar?.resourceUrl}}"
            (load)="onLoad()">
        </div>
        <div class="job-name d-flex flex-column">
          <span class="name text-center font-weight-bold">{{welcome?.welcomeMessage?.name || name}}</span>
          <span class="name text-center">{{welcome?.welcomeMessage?.jobTitle || jobTitle}}</span>
        </div>
      </div> -->
      <div class="description">
        <h1 class="title-intro">{{welcome?.welcomeMessage?.title || title}}</h1>
        <div class="content" [innerHTML]="message"></div>
      </div>
    </div>
    <div class="img-background col-md-12 col-xl-7">
      <div *ngIf="loading" class="d-flex align-items-center justify-content-center w-100 h-100">
        <div class="loader"></div>
      </div>
      <img src="{{welcome?.welcomeMessage?.image?.resourceUrl}}" alt="" [hidden]="loading" (load)="onLoad()" class="w-100">
      <div class="ge-icon-container">
        <img src="../assets/images/vernova-logo-single.png" alt="Icon" class="icon">
      </div>
    </div>
  </div>
  <ng-container *ngIf="type === 'supplier'">
    <div class="gauge-chart">
      <div class="title-chart d-flex flex-row">
        <img src="../assets/images/ge.jpg" alt="" width="50px" height="100%">
        <h1 class="pl-2">Onshore Wind</h1>
      </div>
      <div class="row m-0">
        <li *ngFor="let item of chartName" class="col-lg-6 col-sm-12 col-xl-3 p-0 text-center">
          <div class="kpi-name d-flex justify-content-center align-items-center mb-2">
            <div class="start-letter">{{ item.startLetter }}</div>
            <div class="kpi-type" [ngClass]="item.className()"><h3 style="margin-bottom: 0.3rem !important;">{{item.type}}</h3></div>
          </div>
          <app-gauge-chart [value]="item.v" [min]="item.n" [max]="item.m" [data]="item"></app-gauge-chart>
          <!-- <div class="descrip-chart">
            <span class="value">Value: {{item.v}} {{item.unit}}</span><br>
          </div> -->
        </li>
      </div>
      <div class="d-flex flex-row justify-content-center" style="color: #005E60">
        <span class="material-icons">
          search
        </span>
        <span>Find <a href="/srm/score-card" class="hyperlink font-weight-bold">here</a> more details on <span
            class="font-weight-bold">SCORECARD</span></span>
      </div>
    </div>
    <!-- <div class="mt-1 chartTitle">
      <span>{{chartTitle}}</span>
    </div> -->
  </ng-container>
  <div class="row content-main mt-3">
    <div class="col-md-12 col-lg-7 col-xl-9 p-0">
      <span class="app-title">Applications</span>
      <div class="admin" *ngIf="welcome?.sections">
        <div class="order-fullfillment mb-3" *ngFor="let section of welcome.sections">
          <div class="section-title">
            <span class="firstChar"> {{ getFirstCharacter(section.title) }}</span>
            <span class="title-main">{{ getValueWithoutFirstChar(section.title) }}</span>
          </div>
          <div class="row mt-4">
            <div class="d-flex flex-row mb-4 item-order col-md-12" *ngFor="let app of section.applicationLinks"
              [ngClass]="section.layout === 1 ? 'col-xl-12' : section.layout === 2 ? 'col-xl-6' : 'col-xl-4'">
              <div class="img  p-0">
                <img src="{{app.icon.resourceUrl}}" alt="" class="w-100 h-100" style="object-fit: contain;" loading="lazy">
              </div>
              <div class="col-md-9 p-0 content">
                <a href="{{app.url}}" class="title" target="_blank">{{app.title}}</a><br>
                <span class="des">{{app.description}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news col-md-12 col-lg-5 col-xl-3">
      <span class="app-title">News</span>
      <div class="news-main">
        <ng-container *ngIf="news.length > 0">
          <div class="news-item" *ngFor="let item of news">
            <span class="news-title" (click)="goToNews(item.id)">{{item.title}}</span>
            <div class="d-flex flex-row justify-content-between">
              <span class="news-name">{{item.author}}</span>
              <span class="news-name d-flex justify-content-end">{{item.lastUpdated}}</span>
            </div>
            <span class="news-name" style="-webkit-box-orient: vertical;">{{item.description}}</span>
            <a (click)="goToNews(item.id)" class="hyperlink">Read more</a>
          </div>
        </ng-container>
        <ng-container *ngIf="news.length === 0">
          No Fresh News
        </ng-container>
        <div class="d-flex justify-content-center mt-3 read-all">
          <div class="btn button btn-primary font-weight-bold" style="background-color: #005E60 !important; border-color: #005E60 !important;" (click)="goToNews()">Read All News</div>
        </div>
      </div>
      <span class="app-title mt-4">My ONW Team</span>
      <div class="news-main user-main d-flex flex-column">
        <div class="unknown_user">
          <img src="../assets/images/unknown_person.jpg" alt="">
        </div>
        <span class="author text-center">Nuria Llagostera</span>
        <span class="text-center"> Scorecard </span>
        <span class="mailto text-author"><a
            href="mailto:nuria.llagostera@gevernova.com">nuria.llagostera@gevernova.com</a></span>
      </div>
      <div class="news-main user-main mt-3 d-flex flex-column">
        <div class="unknown_user">
          <img src="../assets/images/unknown_person.jpg" alt="">
        </div>
        <span class="author text-center">B S, Sunil</span>
        <span class="text-center"> Sustainability </span>
        <span class="mailto text-author"><a href="mailto:Sunil.BS@gevernova.com">Sunil.BS@gevernova.com</a></span>
      </div>
    </div>
  </div>
</div>